import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { CloneWeekPayload, CloneWeekResponse } from "app/data/static-load/model";
import { apiQueryAdapter } from "app/data/apiQueryAdapter";
import { ERROR_MESSAGES } from "app/data/common/errorMessages";

export const useCloneWeek = ( onSuccess: () => void) => {
  return useMutation<
    CloneWeekResponse, // response type
    Error,                // error type
    CloneWeekPayload  // variables type
  >({
    mutationFn: async (payload) => {
      const response = await apiQueryAdapter.query<CloneWeekResponse>(
        "/manifest-management/clone",
        "POST",
        { body: payload }
      );

      return response.data;
    },
    onSuccess: () => {
      toast.info("Week cloned successfully");
      onSuccess();
    },
    onError: (e: any) => {
      if (e instanceof Error) {
        toast.error(e.message);
      }
      else if (e?.response?.data?.message) {
        toast.error(e.response.data.message);
      }
      else {
        toast.error(ERROR_MESSAGES.COMMON);
      }
    },
  });
};
